import * as React from 'react';
export const IcDrinks = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8 20.33A2 2 0 0010 22h6a2 2 0 002-1.67L19.36 12H6.64L8 20.33zM21 2h-4a1 1 0 00-.95.68L15 6h-5a4 4 0 10-4 4H19.69L20 8.33a2 2 0 00-1.14-2.15A2 2 0 0018 6h-.95l.67-2H21a1 1 0 100-2zM6.47 6.71A2 2 0 006 8a2 2 0 112-2 2 2 0 00-1.53.71z'
      fill='currentColor'
    />
  </svg>
);
